import {
  checkEviction,
  EvectionCtx,
  getEvictionTS,
  IParamsStore,
  TicketOptions,
  TicketValue,
} from './commmon';

const EVICTION_CHECK = 60 * 1000;

declare global {
  interface Window {
    __GlobalOpenFrontTickets__: TicketsStore;
  }
}

interface TicketsStore {
  tickets: Map<string, TicketValue>;
  permTickets: Map<string, TicketValue>;
  currentId: number;
  evictionTimeout: ReturnType<typeof setTimeout> | undefined;
}

export class MemoryStore implements IParamsStore {
  private ticketsStore: TicketsStore;
  constructor() {
    if (!window.top) throw new Error("Can't get window top");
    if (!window.top.__GlobalOpenFrontTickets__) {
      window.top.__GlobalOpenFrontTickets__ = {
        currentId: 1,
        tickets: new Map(),
        permTickets: new Map(),
        evictionTimeout: undefined,
      };
    }
    this.ticketsStore = window.top.__GlobalOpenFrontTickets__;
  }

  public async ticket(data: unknown, options?: TicketOptions): Promise<string> {
    const id = `tck${this.ticketsStore.currentId}`;
    const eviction = options && options.eviction ? options.eviction : 'onfetch';
    this.ticketsStore.currentId += 1;
    const ticketValue: TicketValue = {
      value: data,
      evictionTS: getEvictionTS(eviction),
      eviction,
    };
    this.ticketsStore[
      ticketValue.eviction === 'never' ? 'permTickets' : 'tickets'
    ].set(id, ticketValue);
    this.checkEvictionTimeout();
    return id;
  }

  public async ticketValue<T>(id: string): Promise<T | undefined> {
    const ticketValue =
      this.ticketsStore.tickets.get(id) ||
      this.ticketsStore.permTickets.get(id);
    if (ticketValue) {
      const context = { currentTS: Date.now(), fetch: true };
      if (checkEviction(ticketValue, context)) {
        this.ticketsStore.tickets.delete(id);
      }
      context.fetch = false;
      if (!checkEviction(ticketValue, context)) {
        return ticketValue.value as T;
      }
    }
    return undefined;
  }

  public async removeTicket(id: string): Promise<void> {
    this.ticketsStore.tickets.delete(id);
    this.ticketsStore.permTickets.delete(id);
  }

  private removeEvictedTickets() {
    const context: EvectionCtx = {
      currentTS: Date.now(),
      fetch: false,
    };
    this.ticketsStore.tickets.forEach((value, id, tickets) => {
      if (checkEviction(value, context)) {
        tickets.delete(id);
      }
    });
    this.ticketsStore.evictionTimeout = undefined;
    this.checkEvictionTimeout();
  }

  private checkEvictionTimeout(): void {
    if (
      this.ticketsStore.evictionTimeout === undefined &&
      this.ticketsStore.tickets.size !== 0
    ) {
      this.ticketsStore.evictionTimeout = setTimeout(
        this.removeEvictedTickets.bind(this),
        EVICTION_CHECK
      );
    }
  }
}
